// Utility to decode JWT and get expiry
export function getTokenExpiry(token: string): number | null {
  if (!token) return null
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp ? payload.exp * 1000 : null // exp is in seconds, convert to ms
  } catch (e) {
    return null
  }
}
